/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-22 15:40:34
 * @LastEditTime: 2025-04-18 13:48:15
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import Service from './service/index'
import FooterBottom from './bottom/footer-bottom'
import { footerContent, footerContact } from './config';
import codeIcon from './imgs/code.png';
import logo from './imgs/logo.svg'
import phone from './imgs/phone.png'
import './index.scss';

function Footer() {
  return (
    <div className='footer-container'>
      <Service />
      <div className='footer-content'>
        <div className="footer-box">
        <div className="footer-box-right">
            <div className="right-each">
              <img src={logo} alt="logo" className='logo-svg'/>
              <p className='sub-title'>{footerContact.subTitle}</p>
              <p className='line'></p>
            <p className='time'>{ footerContact.time}</p>
              {/* <p className='phone'><img src={phone } alt='phone'/>{ footerContact.tel}</p> */}
            </div>
            
          </div>
          <div className="footer-box-left">
          {footerContent.map((item,index) => { 
            return (
              <div className="footer-item" key={index}>
                <p className='footer-item-title'>{item.title}</p>
                {item.children.map(each => { 
                  return (
                    <React.Fragment key={each.title}>
                      {
                        each.link !== ''?
                        <p className="footer-link footer-item-text" onClick={()=>window.open(each.link)}>{each.title}</p>:
                        <p className="footer-item-text" key={each.title}>{each.title}</p>
                      }
                    </React.Fragment>
                  )
                }) }
              </div>
            )
          }) }
          </div>
          
          <div className="right-code">
            <div className="box">
              <img src={codeIcon} alt="code" />
            <p className='code-text'>官方公众号</p>
              </div>
             
            </div>
        </div>

      </div>
      <FooterBottom/>
    </div>
  )
}

export default Footer;